module.exports = __webpack_public_path__ + "OpenSans-Regular.5885cdcbf91568407721.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-Regular.woff2
// module id = ../../../../../src/assets/customfonts/OpenSans-Regular.woff2
// module chunks = styles